import styled from "styled-components";

export const DropdownMenu = styled.div`
  position: relative;
  width: 426px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  box-shadow: #0000001A 0px 0px 15px;
`;

export const MainContent = styled.div`
  height: auto;
  max-height: 322px;
  display: flex;
  flex-direction: column;
  padding: 6px;
  overflow-y: auto;
  gap: 4px;

  .item {
    width: 100%;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border: none;
    border-radius: 6px;
    padding: 0 6px;
    cursor: pointer;

    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 6px;

      .activityIcon {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      }

      .LeftContentIdentifier {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      }

      .LeftContentTitle {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 6px;
    }
    
    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }
  }
`;

interface IStatus {
  bgColor?: string;
  textColor?: string;
}

export const Status = styled.div<IStatus>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ textColor, theme }) => textColor || theme.colors.secondary.onSecondary};
  background-color: ${({ bgColor, theme }) => bgColor || theme.colors.secondary.secondary};
`;

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px;
  gap: 8px;
  background: ${({ theme }) => theme.colors.surface.surface};

  .iconEmpty {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }

  .textEmpty {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px 12px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};

  .textFooter {
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  }
`;
